import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactPlaceholder from 'react-placeholder';
import {
  InputPlaceholder,
  Icon,
  NoTranslate,
  Collapsible
} from '@contently/toolkit';
import CheckboxSection from './checkbox_section';
import fieldTemplateIconMap from '../../../utils/field_template_icon_map';
import { get } from '../../../utils/api';
import { handleError } from '../../../utils/errors';

class FieldTemplatesCheckboxes extends Component {
  static mapFieldTemplates(fieldTemplates, selected) {
    const mapped = fieldTemplates.map(fieldTemplate => ({
      value: fieldTemplate.id,
      label: FieldTemplatesCheckboxes.renderLabel(fieldTemplate),
      contentType: fieldTemplate.content_type,
      checked: (selected || []).includes(fieldTemplate.id)
    }));

    return mapped;
  }

  static selected(options) {
    return options.filter(o => o.checked);
  }

  static renderLabel(item) {
    return (
      <Fragment>
        <Icon type={fieldTemplateIconMap[item.contentType]} withText />
        <NoTranslate text={item.name} />
      </Fragment>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      options: []
    };
  }

  componentDidMount() {
    const { brandProfileId, onFetching, onError } = this.props;
    onFetching('fieldTemplates', true);
    return get(`/api/v1/brand_profiles/${brandProfileId}/field_templates`).then((res) => {
      onFetching('fieldTemplates', false);
      this.setState({
        options: res
      });
    }).catch((error) => {
      handleError(error, () => onError());
    });
  }

  handleChange = (data) => {
    const { onChange } = this.props;
    if (onChange) onChange(data);
  };

  render() {
    const {
      fetching,
      selected
    } = this.props;

    const { options } = this.state;

    const mappedOptions = FieldTemplatesCheckboxes.mapFieldTemplates(options, selected);

    return (
      <ReactPlaceholder
        showLoadingAnimation
        customPlaceholder={<InputPlaceholder wrapperClass="row" withLabel />}
        ready={!fetching}
      >
        <Collapsible
          collapsedText={(
            <span className="subtext">
              {`${FieldTemplatesCheckboxes.selected(mappedOptions).length} fields selected`}
            </span>
          )}
          header="Custom Fields"
          subtext="fields"
          wrapperClassName="row"
        >
          <CheckboxSection onChange={this.handleChange} options={mappedOptions} id="fieldTemplates" />
        </Collapsible>
      </ReactPlaceholder>
    );
  }
}

FieldTemplatesCheckboxes.propTypes = {
  fetching: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  selected: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ])).isRequired,
  brandProfileId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
  onFetching: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired
};

export default FieldTemplatesCheckboxes;



// WEBPACK FOOTER //
// ./app/javascript/app/components/forms/checkboxes/field_templates_checkboxes.jsx